import ApiService from '../apiservice'

export default class Pedido extends ApiService {
  constructor() {
    super('/pedidos');
  }

  listarPedidos(empresa) {
    return this.get(`/${empresa}`);
  }

  cadastrarPedido(pedido) {
    return this.post('/',pedido);
  }

  consultarPedido(codigo) {
    return this.get(`/porCodigo/${codigo}`);
  }

  alterarPedido(pedido) {
    return this.put(`/${pedido.codigo}`, pedido);
  }

  excluirPedido(codigo) {
    return this.delete(`/${codigo}`);
  }
}